module.exports = "<div ng-init=\"flowCtrl.init()\">\n\t<div>\n\t\ta: {{flowCtrl.flow.context.a}}\n\t</div>\n\t<div>\n\t\tb: {{flowCtrl.flow.context.b}}\n\t</div>\n\t<button class=\"btn btn-default\" ng-click=\"flowCtrl.start()\">Start</button>\n\t<button class=\"btn btn-default\" ng-click=\"flowCtrl.step()\">Step</button>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/platform/templates/flow/flow.html
 ** module id = 156
 ** module chunks = 0
 **/